<template>
  <div class="map-wrapper">
    <div id="map">
      <div class="map-button-wrapper">
        <div class="map-button-inner green-border">
          <v-select
            v-model="selectedZone"
            class="filter-input2"
            label="DSO Zone" id="zone" name="zone"
            hide-details
            color="#58c26d"
            @change="changeZone()"
            :items="zones"
            item-text="zoneName"
            item-value="zoneCode"
            dense
            outlined
          ></v-select>
          <v-select
            v-model="selectedLocation"
            class="filter-input2"
            label="Location" id="location" name="location"
            hide-details
            color="#58c26d"
            @change="changeLocation()"
            :items="locations"
            item-text="locationName"
            item-value="locationCode"
            dense
            outlined
          >
          </v-select>
  
      <!-- 
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="filter-input2"
                hide-details
                color="#58c26d"
                v-model="date"
                v-on="on"
                label="Date"
                append-icon="mdi-menu-down"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              color="#329e5e"
              @input="(e) => changeFilterDate(e)"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="filter-input2"
                label="Time"
                v-model="time"
                hide-details
                color="#58c26d"
                append-icon="mdi-menu-down"
                dense
                outlined
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              ref="tpicker"
              color="#329e5e"
              @input="(e) => changeFilterTime(e)"
            ></v-time-picker>
          </v-menu>
          <v-text-field
            class="filter-input2"
            label="Volume"
            v-model="volume"
            hide-details
            color="#58c26d"
            type="number"
            min="0"
            dense
            outlined
          ></v-text-field> 
      -->
        </div>
        
        <div class="map-button-inner green-border" v-if="selectedLocation!=nul">
          <v-card class='energy-info'
            loading
            outlined
          >
            <br>
            <div>
              <div><strong>Requests:</strong> <span id='req' text-align=right>{{this.requestsVolume}} MW</span></div>
            </div>
          </v-card>
          <v-card class='energy-info'
            loading
            outlined
          >
            <br>
            <div>
              <div><strong>Offers:</strong> <span id='off'>{{this.offersVolume}} MW</span></div>
            </div>  
          </v-card>
         
          <div class='trading-button'>
              <v-btn depressed tile color="#58c26d" class="match-button2" v-on:click="trading"> Trading </v-btn>
          </div>
          
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import ZoneDataService from "../../services/ZoneDataService";
import LocationDataService from "../../services/LocationDataService";
import RequestDataService from "../../services/RequestDataService";
import OfferDataService from "../../services/OfferDataService";

const requestDisplay = document.getElementById('req');
const offerDisplay = document.getElementById('off');
const locDisplay = document.getElementById('loc');

export default {
  props: ["map", "matching"],
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoiamFycm9keWVsbGV0cyIsImEiOiJjazZieHI5NXEwNGUwM2ptc3F4ejZ6MmJ5In0.5zZ0n1qoedqjHeuNllLYPw", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/jarrodyellets/ck6byoqcp4k5e1is4565r4vl8", // your map style
      coordinates: [35.2433, 38.9637],
      zoom: 6,
      location: "Turkey",
      zones: [],
      locations: [],
      region: [],
      date: "",
      time: "",
      volume: "",

      zones: [
        {
          zoneCode: "TRDSO16",
          zoneName: "OEDAS - Osmangazi",
        },
      ],

      locations: [
        {
          locationCode: "272",
          locationName: "Afyon",
        },
      ],

      selectedZone: null,
      selectedLocation: null,

      requests: [],
      offers: [],

      //requestsVolume: 79,
      //offersVolume: 65,
      requestsVolume: 0,
      offersVolume: 0,
    };

  
  },
  methods: {

    offerRequest(){
      this.Apps.offerRequest();
    },

    changeFilterTime(e) {
      this.time = e;
    },
    changeFilterDate(e) {
      this.date = e;
    },

    retrieveRequests() {
      if (this.$store.state.auth.user.roles == "ROLE_ADMIN" 
          && this.$store.state.auth.user.username == "admin@localhost.com") {
        RequestDataService.getAll()
        .then((response) => {
            this.requests = response.data;
            console.log("HERE... load requests sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      } else {
        RequestDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
          .then((response) => {
            this.requests = response.data;
            console.log("HERE... load requests sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      }
    },

    retrieveOffers() {
      if (this.$store.state.auth.user.username == "admin@localhost.com") {
        OfferDataService.getAll()
          .then((response) => {
            this.offers = response.data;
            console.log("HERE... load offers sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load offers error: " + e);
          });
      } else {
        OfferDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
          .then((response) => {
            this.offers = response.data;
            console.log("HERE... load offers sucessfull: " + response.data);
          })
          .catch((e) => {
            console.log("HERE... load offers error: " + e);
          });
      }
    },  

    retrieveZones() {
      //ZoneDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
      ZoneDataService.findByCountryCode("TR")
        .then((response) => {
          this.zones = response.data;
          console.log("HERE... retrieve zones sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... retrieve zones error: " + e);
        }); 
    },

    retrieveLocations() {
      console.log("HERE... call retrieveLocations");
      LocationDataService.findByCountryCode(this.selectedZone)
        .then((response) => {
          this.locations = response.data;
          console.log("HERE... retrieve locations sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... retrieve locations error: " + e);
        }); 
    },

    changeZone() {
      console.log("Selected zone: ", this.selectedZone)
      this.$parent.changeDSOZone(this.selectedZone);
      //this.retrieveLocations();
      //this.selectedLocation = this.locations[0].locationCode;
    },

    changeLocation() {
      console.log("Selected location: ", this.selectedLocation);
      this.$parent.changeState(this.selectedLocation);
      //this.retrieveRequests();
      //this.requests = this.requests.filter(request => request.locationCode == this.selectedLocation); 
      //console.log("Filtered requests: ", this.requests);

      console.log("HERE... requests: ", this.requests.length);
      for (var i = 0; i < this.requests.length; i++) {
        if (this.requests[i].locationCode == this.locations[0].locationName) {
          this.requestsVolume = this.requestsVolume + this.requests[i].volume
        }
      }
      console.log("HERE... requestsVolume: ", this.requestsVolume);
      
      //this.retrieveOffers();
      //this.offers = this.offers.filter(offer => offer.locationCode == this.selectedLocation);
      //console.log("Filtered offers: ", this.offers);

      console.log("HERE... offers: ", this.offers.length);
      for (var i = 0; i < this.offers.length; i++) {
        if (this.offers[i].locationCode == this.locations[0].locationName) {
          this.offersVolume = this.offersVolume + this.offers[i].volume
        }
      }
      console.log("HERE... offersVolume: ", this.offersVolume);
    },

    trading() {
      console.log("Selected location: ", this.selectedLocation);

      this.offerRequest();

      if (this.requestsVolume >= this.offersVolume) {
        this.requestsVolume = this.requestsVolume - this.offersVolume;
        this.offersVolume = 0;
      } else {
        this.offersVolume = this.offersVolume - this.requestsVolume;
        this.requestsVolume = 0;
      }

      // set color
      var flag = 0;
      if (this.requestsVolume > 50) {
        flag = 3
      } else if (this.requestsVolume <= 10) {
        flag = 1
      } else {
        flag = 2
      }
      this.$parent.changeStateColor(this.selectedLocation, flag);
    },

  },

  
  mounted() {

    //this.$store.state.auth.user.countryCode == "TR";

    console.log("HERE... test Network Map");
    //this.retrieveZones();
    //this.retrieveLocations();
    this.retrieveRequests();
    this.retrieveOffers();

    for (let match of this.matching) {
      if (this.region.indexOf(match.locationName) === -1) {
        this.region.push(match.locationName);
      }
    }
    this.region = this.region.sort();
  },
};
</script>
<style lang="scss">
#map {
  height: 100%;
  position: relative;
}

.map-button-wrapper {
  position: absolute;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.map-button-inner {
  padding: 5px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  left: -50%;
  display: flex;
}

.map-button-inner .theme--light.v-input,
.map-button-inner .theme--light.v-input input,
.map-button-inner .theme--light.v-input textarea,
.map-button-inner .v-text-field--outlined fieldset {
  border-width: 2px !important;
}

.map-wrapper {
  height: 100%;
}
.mapboxgl-canvas-container {
  height: calc(100vh - 50px) !important;
}
.mapboxgl-canvas {
  width: 100% !important;
}

.mapboxgl-control-container {
  display: none;
}

.filter-input2 {
  margin: 5px !important;
  min-width: 150px;
}

.energy-info {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
  padding: 5px;
  width: 100%;
  border: 2px solid green;
  font-size: 14px;
  color: #222;
  background-color: #fff;
  border-radius: 3px;
} 

.trading-button {
  margin-top: 15px;
  //margin-bottom: 5px;
  margin-left: 10px;
  //margin-right: 5px;
}

</style>